import { Outlet, useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { apiEndpoints, defaultAppTheme } from '../constants/ApplicationConstants';
import { setPageMessage, setProcessing } from '../store/ApplicationStore';
import { addThemeToStore, addUserToStore, updateMuiThme } from '../store/AuthStore';
import { postRequest } from '../utils/ApiUtil';
import { UserSerializer } from '../serializers/UserSerializer';
import UnAuthorisedScreen from '../screens/others/UnAuthorisedScreen';
import { createMuiTheme } from '../utils/AppUtils';

export default function AuthMiddleware({allowedRoles, updateTheme}){
    const { user } = useSelector(state=> state.user);
    const { authState, oktaAuth } = useOktaAuth();
    
    const dispatch= useDispatch()
    const location= useLocation()

    const redirect = location?.pathname

    useEffect(() => {
        async function finishOktaAuth() {
            dispatch(setProcessing(true));
            const isAuthenticated = await oktaAuth.isAuthenticated();
            if (!isAuthenticated) {
                oktaAuth.signInWithRedirect({ originalUri: redirect });
            } else {
                if (authState && authState.accessToken && authState.idToken && !user ) {
                    const response = await postRequest(false, apiEndpoints.backendBaseURL + apiEndpoints.login, {
                        accessToken: authState.accessToken.accessToken,
                        idToken: authState.idToken.idToken,
                    });
                    if (response.isError) {
                        dispatch(setProcessing(false));
                        dispatch(setPageMessage({message: response.message, type: "error"}));
                    }else{
                        const fetchedUser = UserSerializer({ ...response.data, accessToken: authState.accessToken.accessToken });
                        dispatch(setPageMessage({message: response.message, type: "success"}));
                        fetchedUser && dispatch(addUserToStore(fetchedUser));
                        fetchedUser && dispatch(addThemeToStore(fetchedUser.theme));
                        fetchedUser && fetchedUser.theme && dispatch(updateMuiThme(createMuiTheme('light', fetchedUser.theme.light ? fetchedUser.theme.light : defaultAppTheme.light)));
                        dispatch(setProcessing(false));
                    }
                }else{
                    dispatch(setProcessing(false));
                }
            }
        }
        finishOktaAuth();
    }, [authState, dispatch, oktaAuth, redirect, user, updateTheme]);

    return(
        <>
            {user && !allowedRoles.includes(user.role_id) && <UnAuthorisedScreen />}
            {user && allowedRoles.includes(user.role_id) && <Outlet />}
            {!user && <div>Authenticating...</div>}
        </>
    )
}